<template functional>
  <el-tag v-if="props.row[props.column] === true" type="success">Activo</el-tag>
  <el-tag v-else type="danger">Inactivo</el-tag>
</template>

<script>
export default {
  name: "RenderCheckLabel"
};
</script>
